import { OrderStatus } from "@/constants/orderStatus";

const module = {
  namespaced: true,
  state: () => {
    return {
      productionDashboardColumnsData: {
        ProductionApproval: {},
        ProductionScheduled: {},
        InProduction: {},
        Dispatched: {},
        Completed: {},
      },
      productionDashboardHeaderFilters: {
        date_range: null,
        dealers: [],
        search: "",
        selectedStatus: OrderStatus.flatMap((i) => i.code),
      },
    };
  },
  mutations: {
    setFilters(state, payload) {
      state.productionDashboardHeaderFilters = payload;
    },
    setDataColumnData(state, payload) {
      state.productionDashboardColumnsData[payload.code].orders =
        payload.orders;
      state.productionDashboardColumnsData[payload.code].pagination =
        payload.pagination;
      state.productionDashboardColumnsData[payload.code].collapsed =
        payload.collapsed;
    },
  },
  getters: {
    getData(state) {
      return state.productionDashboardColumnsData;
    },
  },
  actions: {
    setDataColumnData({ state, commit }, incomingData) {
      commit("setDataColumnData", incomingData);
    },
    setHeaderFilters({ state, commit }, incomingFilters) {
      commit("setFilters", incomingFilters);
    },
  },
};
export default module;
